<template>
    <div>
        <b-spinner variant="primary"
            class="spinStyle"
            v-show="showSpin"
            label="Text Centered"></b-spinner>
        <!-- 功能按键区 -->
        <b-row style="margin-top:10px;">
            <b-col lg="12">
                <div class="filterBar">
                    <b-row>
                        <b-col lg="3">
                            <b-input-group>
                                <b-form-input size="sm"
                                    v-model="productSearchValue"
                                    placeholder="输入品名或编码"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm"
                                        v-on:click="searchProduct()">查询</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="2">
                            <b-form-select v-model="selectedYear"
                                size="sm"
                                @change="onYearSelectChange">
                                <option :value="0">选择年份</option>
                                <option value="2020">2020年</option>
                                <option value="2021">2021年</option>
                            </b-form-select>
                        </b-col>
                        <b-col lg="7">
                            <b-button size="sm"
                                variant="primary"
                                v-on:click="onShowWeekSelect()">
                                周数选择
                                <b-badge variant="primary">{{selectedMultiWeekList.length}}</b-badge>
                            </b-button>
                            <b-button v-b-toggle.sidebar-cate
                                size="sm"
                                variant="info"
                                style="margin-left:10px">
                                分类选择
                                <b-badge variant="info">{{selectedMultiCateList.length}}</b-badge>
                            </b-button>
                            <b-button v-b-toggle.sidebar-brand
                                size="sm"
                                variant="warning"
                                style="margin-left:10px">
                                品牌选择
                                <b-badge variant="warning">{{selectedMultiBrandList.length}}</b-badge>
                            </b-button>
                            <!-- <b-button
                                size="sm"
                                variant="success"
                                style="margin-left:10px"
                                v-on:click="onShowMyfavorite()"
                            >
                                我的收藏
                                <b-badge variant="success">{{myfavoriteList.length}}</b-badge>
                            </b-button> -->
                            <b-button size="sm"
                                style="margin-left:10px"
                                v-on:click="goToCart()">
                                预售购物车
                                <b-badge>{{cartItems.length}}</b-badge>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div class="dataTable table-responsive">
                    <table id="product-table"
                        data-locale="zh-CN"></table>
                </div>
                <div class="pageControl">
                    <b-pagination v-model="feSearch.limit.conditions.pageStart"
                        style="margin-top:20px;"
                        :total-rows="feSearch.limit.conditions.total"
                        :per-page="feSearch.limit.conditions.pageLength"
                        align="center"
                        size="sm"
                        ellipsis-text="..."
                        first-text="首页"
                        prev-text="上一页"
                        next-text="下一页"
                        last-text="尾页"
                        limit="10"
                        @change="onPageChange"></b-pagination>
                </div>
            </b-col>
        </b-row>
        <!-- 预定窗口 -->
        <b-modal id="bookingModel"
            v-model="bookingModel.show"
            :title="bookingModel.title"
            size="sm">
            <b-row align-v="center">
                <b-col lg="12">
                    <b-form>
                        <b-form-group label="周数:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.weekNumber"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="可购数量:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.offerAmount"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="纸箱费:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.packageFee"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="价格:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.price"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="订购单位:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.step"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="订购数量:"
                            label-cols-lg="4"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="bookingModel.bookingCount"
                                autofocus
                                size="sm"
                                required
                                type="number"
                                :step="bookingModel.step"
                                placeholder="必填"></b-form-input>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm"
                    variant="success"
                    @click="addToCart()">加入购物车</b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="bookingModel.show = false">取消</b-button>
            </template>
        </b-modal>
        <!-- 周数窗口 -->
        <b-modal id="multiWeekSelectModel"
            v-model="multiWeekSelectModel.show"
            :title="multiWeekSelectModel.title"
            size="xl">
            <b-row align-v="center">
                <b-col lg="2"
                    v-for="item in weekList"
                    :key="item.weekSeq">
                    <b-card :header="item.weekKnownTextCh"
                        style="margin-top:10px;"
                        v-bind:class="{ selectcateborder : selectedMultiWeekList.includes(item.weekSeq)}"
                        v-on:click="onSelectMultiWeek(item.weekSeq)">
                        <b-card-text style="font-size:10px;text-align:center;">
                            开始:{{item.weekBeginDate}}
                            <br />
                            结束:{{item.weekEndDate}}
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm"
                    variant="info"
                    @click="multiWeekAllSelect()">{{isSelectAllWeek?'取消全选':'全选'}}</b-button>
                <b-button size="sm"
                    variant="success"
                    @click="confirmMultiWeekSelect()">确认</b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="multiWeekSelectModel.show = false">取消</b-button>
            </template>
        </b-modal>
        <!-- 品牌边栏 -->
        <b-sidebar id="sidebar-brand"
            title="品牌选择"
            width="600px"
            shadow>
            <template v-slot:footer="{ hide }">
                <div style="width:100%;text-align:right;padding:10px;">
                    <b-button variant="success"
                        size="sm"
                        @click="confirmMultiBrandSearch()">确定</b-button>
                    <b-button variant="warning"
                        size="sm"
                        @click="onResetMultiBrand()">重置</b-button>
                    <b-button variant="danger"
                        size="sm"
                        @click="hide">关闭</b-button>
                </div>
            </template>
            <div style="padding:10px;">
                <div style="color:black;font-weight:bold;">全部品牌</div>
                <div>
                    <a href="#"
                        class="sidebar-subcate"
                        v-for="brand in filterBrandList"
                        :key="brand.brandUuid"
                        v-bind:class="{ selectcatefont : selectedMultiBrandList.includes(brand.brandUuid)}"
                        v-on:click="onSelectMultiBrand(brand.brandUuid)">
                        {{brand.brandName}}</a>
                </div>
            </div>
        </b-sidebar>
        <!-- 分类边栏 -->
        <b-sidebar id="sidebar-cate"
            title="分类选择"
            width="600px"
            shadow>
            <template v-slot:footer="{ hide }">
                <div style="width:100%;text-align:right;padding:10px;">
                    <b-button variant="success"
                        size="sm"
                        @click="confirmMultiCateSearch()">确定</b-button>
                    <b-button variant="warning"
                        size="sm"
                        @click="onResetMultiCate()">重置</b-button>
                    <b-button variant="danger"
                        size="sm"
                        @click="hide">关闭</b-button>
                </div>
            </template>
            <div style="padding:10px;">
                <div style="margin-bottom:10px;"
                    v-for="main in mainCateList"
                    :key="main.mainCategoryUuid">
                    <div style="color:black;font-weight:bold;">{{main.mainCategoryName}}</div>
                    <div>
                        <a href="#"
                            class="sidebar-subcate"
                            v-for="sub in subCateList.filter(e => {return e.subCategoryMainUuid === main.mainCategoryUuid;})"
                            :key="sub.subCategoryUuid"
                            v-bind:class="{ selectcatefont : selectedMultiCateList.includes(sub.subCategoryUuid)}"
                            v-on:click="onSelectMultiCate(sub.subCategoryUuid)">
                            {{sub.subCategoryName}}</a>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import api from "@/api/api";
import search from "@/libs/search";
import { numberToFixed } from "@/libs/utils";
import $ from "jquery";
import "bootstrap-table";
import "bootstrap-table/dist/bootstrap-table.css";
import "bootstrap-table/dist/bootstrap-table-locale-all";
import "bootstrap-table/dist/extensions/fixed-columns/bootstrap-table-fixed-columns";
import "bootstrap-table/dist/extensions/fixed-columns/bootstrap-table-fixed-columns.css";
import "@/style/global.css";

export default {
    name: "FastBooking",
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: "MemberLogin"
            });
            return;
        }
        //从商品详细页的跳转
        if (this.$route.query.productName) {
            this.productSearchValue = this.$route.query.productName;
            let field = "CONCAT(productName, productCode)";
            search.globalRemoveFilterConditionKey(this.feSearch, field);
            this.feSearch.filters.conditions.push({
                name: field,
                type: 'like',
                value: this.productSearchValue
            });
        }
        this.feSearch.filters.enable = true;
        this.getBookingCartList();
        this.getSalesPageData();
        this.setInitialWeekData();
        this.getMyFavorite();
    },
    data() {
        return {
            showSpin: false,
            isTableBusy: false,
            loadingInterval: 300,
            fixedNumber: 8,
            productFields: [
                {
                    field: "productImg",
                    title: "缩图",
                    formatter: function (index, row) {
                        let image
                            = '<a href="#/product/product-detail?productUuid='
                            + row.productUuid
                            + '" rel="noopener" target="_blank"><img width="30" height="30" src="'
                            + row.productFinishImageFile.url
                            + '"></a>';
                        return image;
                    }
                },
                { field: "productCode", title: "编码" },
                { field: "productName", title: "品名", class: 'table-field-align-left' },
                { field: "productSpec", title: "规格" },
                { field: 'mainCategoryName', title: '大类', class: 'table-field-align-left' },
                { field: 'subCategoryName', title: '小类', class: 'table-field-align-left' },
                { field: "brandName", title: "品牌", class: "W100" },
                // { field: 'unitName', title: '单位' },
                { field: "packageName", title: "纸箱号" }
                // { field: 'packageQuantity', title: '装箱量' },
                // { field: 'preSalePlanPrice', title: '单价' }
                // { field: "productMinPurchaseLimit", title: "最少订购量" }
            ],
            allColumns: [],
            prodcutItems: [],
            cartItems: [],
            feSearch: search.getSearchParams(),
            mainCateList: [],
            subCateList: [],
            brandList: [],
            filterBrandList: [],
            productSearchValue: "",

            allWeeks: [],
            selectedYear: 0,
            yearList: [2020, 2021],
            selectedWeek: 0,
            weekList: [],

            bookingModel: {
                show: false,
                title: "",
                bookingCount: 0,
                weekNumber: '',
                offerAmount: '',
                planUuid: "",
                packageFee: 0,
                price: 0,
                step: 10
            },

            selectedMultiCateList: [],
            isNeedUpdateBrand: false,
            selectedMultiBrandList: [],

            isSelectAllWeek: true,
            selectedMultiWeekList: [],
            multiWeekSelectModel: {
                show: false,
                title: "周数选择"
            },

            myfavoriteList: []
        };
    },
    methods: {
        numberToFixed,
        onShowWeekSelect() {
            this.multiWeekSelectModel.show = true;
        },
        onResetMultiCate() {
            this.selectedMultiCateList = [];
            this.confirmMultiCateSearch();
        },
        onSelectMultiCate(cateUuid) {
            let index = this.selectedMultiCateList.indexOf(cateUuid);
            if (index === -1) {
                this.selectedMultiCateList.push(cateUuid);
            }
            else {
                this.selectedMultiCateList.splice(index, 1);
            }
        },
        confirmMultiCateSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(
                this.feSearch,
                "productSubCategoryUuid"
            );
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiCateList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: "productSubCategoryUuid",
                    type: "in",
                    value: JSON.stringify(this.selectedMultiCateList)
                });
            }
            // this.isNeedUpdateBrand = true;
            //清除品牌选择信息
            search.globalRemoveFilterConditionKey(
                this.feSearch,
                "productBrandUuid"
            );
            this.selectedMultiBrandList = [];
            this.getProductList();
        },
        onResetMultiBrand() {
            this.selectedMultiBrandList = [];
            this.confirmMultiBrandSearch();
        },
        onSelectMultiBrand(brandUuid) {
            let index = this.selectedMultiBrandList.indexOf(brandUuid);
            if (index === -1) {
                this.selectedMultiBrandList.push(brandUuid);
            }
            else {
                this.selectedMultiBrandList.splice(index, 1);
            }
        },
        confirmMultiBrandSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(
                this.feSearch,
                "productBrandUuid"
            );
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiBrandList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: "productBrandUuid",
                    type: "in",
                    value: JSON.stringify(this.selectedMultiBrandList)
                });
            }
            this.getProductList();
        },
        onSelectMultiWeek(weekSeq) {
            let index = this.selectedMultiWeekList.indexOf(weekSeq);
            if (index === -1) {
                this.selectedMultiWeekList.push(weekSeq);
            }
            else {
                this.selectedMultiWeekList.splice(index, 1);
            }
        },
        confirmMultiWeekSelect() {
            for (let i = this.fixedNumber; i < this.allColumns.length; i++) {
                let tempColumn = this.allColumns[i];
                if (this.selectedMultiWeekList.includes(tempColumn.field)) {
                    tempColumn.visible = true;
                }
                else {
                    tempColumn.visible = false;
                }
            }
            this.multiWeekSelectModel.show = false;
            this.buildTable();
            this.getProductList();
        },
        multiWeekAllSelect() {
            if (this.isSelectAllWeek) {
                this.selectedMultiWeekList = [];
            }
            else {
                this.selectedMultiWeekList = this.weekList.map(e => {
                    return e.weekSeq;
                });
            }
            this.isSelectAllWeek = !this.isSelectAllWeek;
        },
        onShowMyfavorite() {
            this.feSearch.isFav = true;
            search.globalRemoveFilterConditionKey(
                this.feSearch,
                "productSubCategoryUuid"
            );
            search.globalRemoveFilterConditionKey(
                this.feSearch,
                "productBrandUuid"
            );
            search.globalRemoveFilterConditionKey(this.feSearch, "productName");
            this.feSearch.token = this.getLoginCookieLoginToken();
            this.getProductList();
        },
        getMyFavorite() {
            // let data = {
            //     token: this.getLoginCookieLoginToken()
            // };
            // api.webGetMyFavProducts(data).then(res => {
            //     this.myfavoriteList = res.data.products;
            // });
        },
        arrDistict(arr) {
            let hash = [];
            for (let i = 0; i < arr.length; i++) {
                if (hash.indexOf(arr[i]) == -1) {
                    hash.push(arr[i]);
                }
            }
            return hash;
        },
        getNowString() {
            let now = new Date();
            let year = now.getFullYear();
            let month = now.getMonth() + 1;
            if (month < 10) {
                month = "0" + month;
            }
            let day = now.getDate();
            if (day < 10) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        },
        buildTable() {
            let vm = this;
            $("#product-table").bootstrapTable("destroy");
            $("#product-table").bootstrapTable({
                columns: this.allColumns,
                data: this.prodcutItems,
                fixedColumns:
                    this.selectedMultiWeekList.length > 5 ? true : false, //考虑到样式的问题，选择大于5周时，才冻结列
                fixedNumber: this.fixedNumber,
                onClickCell: function (field, value, row, $element) {
                    let planUUid = row[field + "_plan_uuid"];
                    if (planUUid) {
                        vm.bookingModel.title = row.productName;
                        vm.bookingModel.weekNumber = vm.selectedYear + "年 第" + field + "周";
                        vm.bookingModel.offerAmount = row[field + "_offer_amount"];
                        vm.bookingModel.planUuid = planUUid;
                        vm.bookingModel.bookingCount = parseInt(row[field + "_booking_count"]);
                        vm.bookingModel.packageFee = row.packagePrice;
                        vm.bookingModel.price = vm.numberToFixed(row.productPreSaleDisplayPrice, 2);
                        vm.bookingModel.step = row.productIncreaseStepAmount;
                        vm.bookingModel.show = true;
                    }
                }
            });
        },
        setInitialWeekData() {
            this.selectedYear = 2020;
            this.onYearSelectChange(this.selectedYear);
        },
        onYearSelectChange(year) {
            api.webGetWeekConfig({ years: [year] }).then(res => {
                if (res.code === 0) {
                    this.allWeeks = res.data;
                    let nowString = this.getNowString();

                    this.weekList = this.allWeeks.filter(e => {
                        return (
                            e.weekYear === parseInt(year)
                            && e.weekEndDate > nowString
                        );
                    });
                    this.allColumns = [];
                    this.allColumns = this.allColumns.concat(
                        this.productFields
                    );
                    this.weekList.forEach(e => {
                        this.allColumns.push({
                            field: e.weekSeq,
                            // title: this.selectedYear + '年 第' + e.weekSeq + '周' + '<br>' + e.weekBeginDate + '~' + e.weekEndDate
                            title:
                                this.selectedYear + "年 第" + e.weekSeq + "周"
                        });
                    });
                    //默认选中第一周
                    this.selectedMultiWeekList = this.weekList.slice(0, 1).map(e => {
                        return e.weekSeq;
                    });
                    this.confirmMultiWeekSelect();
                }
            });
        },
        getSalesPageData() {
            api.getSalesPageData({ saleType: "preSale" }).then(res => {
                console.log(res);
                if (res.code === 0) {
                    this.mainCateList = res.data.mainCateList.records;
                    this.subCateList = res.data.subCateList.records;
                    this.subCateList.forEach(e => {
                        if (e.subCategoryFile) {
                            e.subCategoryFile = JSON.parse(e.subCategoryFile);
                            e.subCategoryFile.url = api.fileServer + e.subCategoryFile.url;
                        }
                    });
                    this.brandList = res.data.brandList.records;
                    this.filterBrandList = res.data.brandList.records;
                    this.brandList.forEach(e => {
                        if (e.brandMainImageFile) {
                            e.brandMainImageFile = JSON.parse(e.brandMainImageFile);
                            e.brandMainImageFile.url = api.fileServer + e.brandMainImageFile.url;
                        }
                    });
                }
            });
        },
        getBookingCartList() {
            this.cartItems = [];
            setTimeout(() => {
                api.webPreSaleGetMyCart().then(res => {
                    if (res.code === 0) {
                        this.cartItems = res.data.cartItems.filter(e => {
                            return e.preSaleShoppingCartDistributionStationUuid === this.getStationUuid() && e.preSaleShoppingCartDistUuid === this.getAddressDistUuid();
                        });
                        this.reloadTableData();
                    }
                });
            }, this.loadingInterval);
        },
        getAlreadyBookingCount(planUuid) {
            let carItem = this.cartItems.find(e => {
                return e.preSaleShoppingCartPlanUuid === planUuid;
            });
            return carItem ? carItem.preSaleShoppingCartOrderQuantity : 0;
        },
        getProductList() {
            if (this.getAddressDistUuid() === '') {
                this.$bvModal.msgBoxOk("请选择种植地", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                return;
            }
            if (this.getStationUuid() === '') {
                this.$bvModal.msgBoxOk("请选择配送站", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                return;
            }

            $("#product-table").bootstrapTable("showLoading");
            this.feSearch.year = parseInt(this.selectedYear);
            this.feSearch.weeks = this.selectedMultiWeekList;
            this.feSearch.distributionStationUuid = this.getStationUuid();
            this.feSearch.distUuid = this.getAddressDistUuid();
            // this.feSearch.weeks = this.weekList.map(e => {
            //     return e.weekSeq;
            // });
            api.webGetPreSaleProductList(this.feSearch).then(res => {
                $("#product-table").bootstrapTable("hideLoading");
                if (res.code === 0) {
                    this.prodcutItems = res.data.records;
                    console.log(this.prodcutItems);
                    this.prodcutItems.forEach(p => {
                        if (p.productFinishImageFile) {
                            p.productFinishImageFile = JSON.parse(p.productFinishImageFile);
                            p.productFinishImageFile.url = api.fileServer + p.productFinishImageFile.url;
                        }
                    });
                    search.globalSetFilterRecordCount(
                        this.feSearch,
                        res.data.filterRecordCount
                    );

                    this.reloadTableData();

                    // if (this.isNeedUpdateBrand) {
                    //     this.isNeedUpdateBrand = false;

                    //     let brands = Object.keys(res.data.brands);
                    //     this.filterBrandList = this.brandList.filter(e => {
                    //         return brands.includes(e.brandUuid);
                    //     });
                    // }
                }
            });
        },
        reloadTableData() {
            this.prodcutItems.forEach(p => {
                this.selectedMultiWeekList.forEach(week => {
                    if (p.plans[week].preSalePlanUuid) {
                        let alreadyBookingCount = this.getAlreadyBookingCount(
                            p.plans[week].preSalePlanUuid
                        );
                        let priceText = '<span style="color:red;font-weight:bold;">￥' + this.numberToFixed(p.plans[week].preSalePlanDisplayPrice, 2) + "</span>";
                        let alreadyBookingCountText = "0";
                        if (alreadyBookingCount > 0) {
                            alreadyBookingCountText = '<span style="color:blue;font-weight:bold;">' + alreadyBookingCount + "</span>";
                        }
                        p[week] = priceText + " / " + alreadyBookingCountText + " / " + p.plans[week].preSalePlanOfferAmount;
                        p[week + "_plan_uuid"] = p.plans[week].preSalePlanUuid;
                        p[week + "_offer_amount"] = p.plans[week].preSalePlanOfferAmount;
                        p[week + "_booking_count"] = alreadyBookingCount;
                    }
                    else {
                        p[week] = "未定价";
                    }
                });
            });
            $("#product-table").bootstrapTable("load", this.prodcutItems);
        },
        searchProduct() {
            let field = 'concat(productName, productCode)';
            search.globalRemoveFilterConditionKey(this.feSearch, field);
            this.feSearch.filters.conditions.push({
                name: field,
                type: "like",
                value: this.productSearchValue
            });
            this.getProductList();
        },
        //加入购物车
        addToCart() {
            if (this.bookingModel.bookingCount % this.bookingModel.step !== 0) {
                this.$bvModal.msgBoxOk("订购数量必须是最小订购单位的整数倍", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                return;
            }
            let cartItems = [];
            cartItems.push({
                distributionStationUuid: this.getStationUuid(),
                distUuid: this.getAddressDistUuid(),
                planUuid: this.bookingModel.planUuid,
                orderQuantity: this.bookingModel.bookingCount
            });
            this.showSpin = true;
            api.webPreSaleAddToCart({ cartItems: cartItems }).then(res => {
                this.showSpin = false;
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("订购成功", {
                        title: "提示",
                        buttonSize: "sm",
                        size: "sm"
                    });
                    this.getBookingCartList();
                    this.bookingModel.show = false;
                }
            });
        },
        onPageChange(pageNum) {
            search.globalPageOnChange(this.feSearch, pageNum);
            this.getProductList();
        },
        goToCart() {
            let routeUrl = this.$router.push({
                path: "/member/cart-list",
                query: { tabIndex: 1 }
            });
        }
    },
    components: {}
};
</script>

<style>
.sidebar-subcate {
    margin-left: 20px;
    margin-bottom: 6px;
    word-break: keep-all;
    display: inline-block;
    text-decoration: none !important;
    color: grey;
}
.table-field-align-left {
    text-align: left !important;
}

.W100 .th-inner {
    /* width: 100px !important; */
}

.col-lg-2,
.col-lg-3 {
    padding-right: 0;
}

.table td {
    padding: 6px !important;
}

.selectcateborder {
    border: solid 2px red !important;
}

.selectcatefont {
    color: red !important;
}


#multiWeekSelectModel .card {
    width: 150px !important;
}

#multiWeekSelectModel .card-header {
    padding: 4px 4px;
    text-align: center;
    color: royalblue;
}

#multiWeekSelectModel .card-body {
    padding: 10px;
}
#multiWeekSelectModel .card-body p.card-text {
    font-size: 12px !important;
}

.v-step {
    z-index: 9999;
}

.card-img,
.card-img-top {
    height: 62px;
}

#sidebar-brand,#sidebar-cate{background-color:#fff !important;}
#sidebar-brand a:hover,#sidebar-cate a:hover{color:#1c9a5b;}
.b-sidebar > .b-sidebar-header{backgrond-color:#f7f7f7;}
.close:focus{outline: none;}
</style>



// WEBPACK FOOTER //
// src/view/booking/fast-booking.vue